export const ERRORS = {
  DIFF_ERROR: 'Error Generating Pipeline Diff',
  DEPLOY_ERROR: 'Error Deploying Pipeline',
};
